import * as Yup from "yup"

import i18n from "@/i18n"

export const signInSchema = Yup.object({
  email: Yup.string()
    .email(i18n.t("app.settings.users.errors.email_invalid"))
    .required(i18n.t("app.settings.users.errors.email_required")),
  password: Yup.string().required(i18n.t("app.settings.users.errors.password_required")),
})

export const signUpSchema = Yup.object({
  firstName: Yup.string().required(i18n.t("app.settings.users.errors.first_name_required")),
  lastName: Yup.string().required(i18n.t("app.settings.users.errors.last_name_required")),
  phone: Yup.string().required(i18n.t("app.public.new_reservation.errors.phone_required")),
  email: Yup.string()
    .email(i18n.t("app.settings.users.errors.email_invalid"))
    .required(i18n.t("app.settings.users.errors.email_required")),
  password: Yup.string()
    .min(8, i18n.t("app.settings.users.errors.password_min_length"))
    .required(i18n.t("app.settings.users.errors.password_required")),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password")], i18n.t("app.settings.users.errors.passwords_must_match"))
    .required(i18n.t("app.settings.users.errors.password_confirmation_required")),
  businessName: Yup.string().required(i18n.t("app.auth.sign_up.errors.business_name_required")),
  country: Yup.string().required(i18n.t("app.auth.sign_up.errors.country_required")),
  acceptedTerms: Yup.boolean().oneOf([true], i18n.t("app.auth.sign_up.errors.terms_required")),
})

export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email(i18n.t("app.settings.users.errors.email_invalid"))
    .required(i18n.t("app.settings.users.errors.email_required")),
})

export const resetPasswordSchema = Yup.object({
  password: Yup.string()
    .min(8, i18n.t("app.settings.users.errors.password_min_length"))
    .required(i18n.t("app.settings.users.errors.password_required")),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password")], i18n.t("app.settings.users.errors.passwords_must_match"))
    .required(i18n.t("app.settings.users.errors.password_confirmation_required")),
})
